import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//All Components import here

import { HomeComponent } from './views/home/home.component';
import { AboutUsComponent } from './views/about-us/about-us.component';
import { PrincipalMsgComponent } from './views/principal-msg/principal-msg.component';
import { ManagerMsgComponent } from './views/manager-msg/manager-msg.component';
import { SalientFeaturesComponent } from './views/salient-features/salient-features.component';
import { ObjectivesComponent } from './views/objectives/objectives.component';
import { AddmissionComponent } from './views/addmission/addmission.component';
import { DisciplineComponent } from './views/discipline/discipline.component';
import { CodeOfParentsComponent } from './views/code-of-parents/code-of-parents.component';
import { CodeOfStudentsComponent } from './views/code-of-students/code-of-students.component';
import { TransportationComponent } from './views/transportation/transportation.component';
import { FeeComponent } from './views/fee/fee.component';
import { SchoolTimingComponent } from './views/school-timing/school-timing.component';
import { ImgGalleryComponent } from './views/img-gallery/img-gallery.component';
import { VideoGalleryComponent } from './views/video-gallery/video-gallery.component';
import { OnlineFeeComponent } from './views/online-fee/online-fee.component';
import { ContactUsComponent } from './views/contact-us/contact-us.component';
import { NoticesComponent } from './views/notices/notices.component';
import { ThanksComponent } from './views/thanks/thanks.component';
import { ExpectationsComponent } from './views/expectations/expectations.component';
import { PrayersComponent } from './views/prayers/prayers.component';
import { UniformComponent } from './views/uniform/uniform.component';
import { WithdrawalComponent } from './views/withdrawal/withdrawal.component';
import { ToppersComponent } from './views/toppers/toppers.component';
import { AchievementsComponent } from './views/achievements/achievements.component';
import { StuHeadsComponent } from './views/stu-heads/stu-heads.component';
import { CabinetComponent } from './views/cabinet/cabinet.component';
import { StaffGroupComponent } from './views/staff-group/staff-group.component';
import { FounderComponent } from './views/founder/founder.component';
// import { GuestBookComponent } from './views/guest-book/guest-book.component';
import { SitemapComponent } from './views/sitemap/sitemap.component';
import { ImageDetailsComponent } from './views/image-details/image-details.component';
import { StaffComponent } from './views/staff/staff.component';
import { BirthdayComponent } from './views/birthday/birthday.component';
import { VisionComponent } from './views/vision/vision.component';
import { SoonComponent } from './views/soon/soon.component';
import { CarouselComponent } from './views/carousel/carousel.component';
import { ExmintionComponent } from './views/exmintion/exmintion.component';
import { TipsComponent } from './views/tips/tips.component';
import { ProfileComponent } from './views/profile/profile.component';
import { SkillsComponent } from './views/skills/skills.component';
import { CommitteesComponent } from './views/committees/committees.component';
import { MottoComponent } from './views/motto/motto.component';
import { PrayasComponent } from './views/prayas/prayas.component';
import { HeadboyComponent } from './views/headboy/headboy.component';
import { HeadgirlComponent } from './views/headgirl/headgirl.component';
import { NccComponent } from './views/ncc/ncc.component';
import { FacilitiesComponent } from './views/facilities/facilities.component';
import { ActivitesComponent } from './views/activites/activites.component';
import { FutureComponent } from './views/future/future.component';
import { TripComponent } from './views/trip/trip.component';
import { CeromonyComponent } from './views/ceromony/ceromony.component';
import { TeacherComponent } from './views/teacher/teacher.component';
import { TrusteeComponent } from './views/trustee/trustee.component';
import { CertificatesComponent } from './views/certificates/certificates.component';
import { AcadmicsComponent } from './views/acadmics/acadmics.component';
import { CurriculamComponent } from './views/curriculam/curriculam.component';
import { AssessmentComponent } from './views/assessment/assessment.component';
import { PromotionComponent } from './views/promotion/promotion.component';
import { PatronComponent } from './views/patron/patron.component';
import { DirectorComponent } from './views/director/director.component';
import { PledgeComponent } from './views/pledge/pledge.component';
import { AdministrationComponent } from './views/administration/administration.component';
import { AffilationComponent } from './views/affilation/affilation.component';
import { MediumComponent } from './views/medium/medium.component';
import { ExaminationComponent } from './views/examination/examination.component';
import { LeaveRuleComponent } from './views/leave-rule/leave-rule.component';
import { LibComponent } from './views/lib/lib.component';
import { Prayer2Component } from './views/prayer2/prayer2.component';
import { GeneralHintsComponent } from './views/general-hints/general-hints.component';
import { SpiritualHintsComponent } from './views/spiritual-hints/spiritual-hints.component';
import { BehaviourComponent } from './views/behaviour/behaviour.component';
import { CardsComponent } from './views/cards/cards.component';
import { HelpsComponent } from './views/helps/helps.component';
import { ProudComponent } from './views/proud/proud.component';
import { FeeStructureComponent } from './views/fee-structure/fee-structure.component';

//ends import here ---


const routes: Routes = [
  { path: '',   redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'principal-msg', component: PrincipalMsgComponent },
  { path: 'manager-msg', component: ManagerMsgComponent },
  { path: 'salient-features', component: SalientFeaturesComponent },
  { path: 'objectives', component: ObjectivesComponent },
  { path: 'addmission', component: AddmissionComponent },
  { path: 'discipline', component: DisciplineComponent },
  { path: 'code-of-parents', component: CodeOfParentsComponent },
  { path: 'code-of-students', component: CodeOfStudentsComponent },
  { path: 'transportation', component: TransportationComponent },
  { path: 'fee', component: FeeComponent },
  { path: 'school-timing', component: SchoolTimingComponent },
  { path: 'img-gallery', component: ImgGalleryComponent },
  { path: 'video-gallery', component: VideoGalleryComponent },
  { path: 'online-fee', component: OnlineFeeComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'notices', component: NoticesComponent },
  { path: 'notices/:id', component: NoticesComponent },
  { path: 'thanks', component: ThanksComponent },
  { path: 'expectations', component: ExpectationsComponent },
  { path: 'prayers', component: PrayersComponent },
  { path: 'uniform', component: UniformComponent },
  { path: 'withdrawal', component: WithdrawalComponent },
  { path: 'toppers', component: ToppersComponent },
  { path: 'achievements', component: AchievementsComponent },
  { path: 'stu-heads', component: StuHeadsComponent },
  { path: 'cabinet', component: CabinetComponent },
  { path: 'staff-group', component: StaffGroupComponent },
  // { path: 'guest-book', component: GuestBookComponent },
  { path: 'sitemap', component: SitemapComponent },
  { path: 'image-details/:id', component: ImageDetailsComponent },
  { path: 'staff', component: StaffComponent },
  { path: 'birthday', component: BirthdayComponent },
  { path: 'vision', component: VisionComponent },
  { path: 'soon', component: SoonComponent },
  { path: 'carousel', component: CarouselComponent },
  { path: 'examintion', component: ExmintionComponent },
  { path: 'tips', component: TipsComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'skills', component: SkillsComponent },
  { path: 'founder', component: FounderComponent },
  { path: 'committees', component: CommitteesComponent },
  { path: 'motto', component: MottoComponent },
  { path: 'prayas', component: PrayasComponent },
  { path: 'headboy', component: HeadboyComponent },
  { path: 'headgirl', component: HeadgirlComponent },
  { path: 'ncc', component: NccComponent },
  { path: 'facilities', component: FacilitiesComponent },
  { path: 'activites', component: ActivitesComponent },
  { path: 'future', component: FutureComponent },
  { path: 'trip', component: TripComponent },
  { path: 'ceromony', component: CeromonyComponent },
  { path: 'teacher', component: TeacherComponent },
  { path: 'trustee', component: TrusteeComponent },
  { path: 'certificates', component: CertificatesComponent },
  { path: 'acadmics', component: AcadmicsComponent },
  { path: 'curriculam', component: CurriculamComponent },
  { path: 'assessment', component: AssessmentComponent },
  { path: 'promotion', component: PromotionComponent },
  { path: 'patron', component: PatronComponent },
  { path: 'director', component: DirectorComponent },
  { path: 'pledge', component: PledgeComponent },
  { path: 'administration', component: AdministrationComponent },
  { path: 'affilation', component: AffilationComponent },
  { path: 'medium', component: MediumComponent },
  { path: 'examination', component: ExaminationComponent },
  { path: 'leave-rule', component: LeaveRuleComponent },
  { path: 'lib', component: LibComponent },
  { path: 'prayer2', component: Prayer2Component },
  { path: 'spiritual-hints', component: SpiritualHintsComponent },
  { path: 'general-hints', component: GeneralHintsComponent },
  { path: 'behaviour', component: BehaviourComponent },
  { path: 'cards', component: CardsComponent },
  { path: 'helps', component: HelpsComponent },
  { path: 'proud', component: ProudComponent },
  { path: 'fee-structure', component: FeeStructureComponent },

 

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
